var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"esp-page",style:({'height' : _vm.height,'backgroundColor':_vm.bgcolor })},[_c('div',{staticClass:"esp-page-floatbtn",style:(_vm.style)},[_vm._t("floatBtn")],2),_vm._v(" "),_c('div',{staticClass:"white-content",class:_vm.showShandow?'content-shandow':'',style:({'backgroundColor':_vm.bgContentcolor })},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8652459c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/EspPage.vue
// module id = null
// module chunks = 